import React from 'react'
import './Navbar.css';
import { NavLink } from 'react-router-dom'

const Navbar = () => {
    return (
        <>
            <div className='container-fluid nav_bg shadow bg-black rounded'>
                <div className='row '>
                    <div className='col-12 mx-auto'>
                        <nav className="navbar navbar-expand-lg navbar-light">
                            <div className="container-fluid p-0">
                                <NavLink className="navbar-brand" to="/">
                                <img src="./logo.png" alt=""  className='brand-img'/>
                                </NavLink>
                                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                    <span className="navbar-toggler-icon"></span>
                                </button>
                                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                                    <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                                        <li className="nav-item">
                                            <NavLink activeclassname="menu_active" className="nav-link" aria-current="page" to="/">Home</NavLink>
                                        </li>
                                        <li className="nav-item dropdown">
                                            <NavLink className="nav-link dropdown-toggle" to="cot" id="navbarDropdown" role="button" aria-haspopup="true" aria-expanded="false" data-bs-toggle="collapse" data-bs-target="#dropdowncontent" aria-controls="dropdowncontent" >
                                                COT Reports
                                            </NavLink>
                                            <div className="dropdown-menu" aria-labelledby="navbarDropdown" id="dropdowncontent">
                                                <NavLink className="nav-link" to="cot">COT</NavLink>
                                                <NavLink className="nav-link" to="cot/futures">COT Futures</NavLink>
                                                <NavLink className="nav-link" to="cot/legacy-futures">COT Legacy Futures</NavLink>
                                            </div>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink activeclassname="menu_active" className="nav-link" to="help">Help</NavLink>
                                        </li>
                                        <li className="nav-item">
                                            <NavLink activeclassname="menu_active" className="nav-link" to="about">About</NavLink>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Navbar